<template>
  <div class="cp-backoffice-view" v-if="isLoggedIn">
    <Navigation />
    <div class="cp-backoffice-view-container">
      <Sidebar />
      <router-view name="backoffice-view" />
    </div>
  </div>
</template>

<script>
import Navigation from '@/components/backoffice/Navigation.vue';
import Sidebar from '@/components/backoffice/Sidebar.vue';
// import { getUser } from '@/apis/user';

export default {
  name: 'AdminView',
  components: {
    Navigation,
    Sidebar,
  },
  data() {
    return {
      isLoggedIn: false,
    };
  },
  async mounted() {
    try {
      // await getUser();

      this.isLoggedIn = true;
    } catch (error) {
      // console.error(error);
      // console.log(error);
      this.$router.replace({
        name: 'BackofficeLoginView',
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.cp-backoffice-view {
  display: flex;
  flex-direction: column;
  height: 100vh;

  &-container {
    flex-grow: 1;
    display: flex;
  }
}
</style>
